export default function usabilityReducer(state = null, action) {
  switch (action.type) {
    case 'SET_USABILITY':
      return action.payload
    default:
      return state
  }
}
